import React, { ReactNode } from "react";
import * as FaIcons from "react-icons/fa";
//import * as AiIcons from "react-icons/ai";
import * as RiIcons from "react-icons/ri";
//import { FcDataConfiguration } from "react-icons/fc";
import { IoMdExit } from "react-icons/io";
import { FaUserGear } from "react-icons/fa6";
//import { GiBiceps } from "react-icons/gi";

export type SidebarItem = {
  title: string;
  path: string;
  icon: ReactNode;
  cName: string;
  hasOnClick: boolean;
  iconClosed?: ReactNode;
  iconOpened?: ReactNode;
  subNav?: SidebarItem[];
};

export const SidebarData: SidebarItem[] = [
  {
    title: "Perfil",
    path: "/admin-home",
    icon: <FaIcons.FaUser />,
    cName: "nav-text",
    hasOnClick: true,
  },
  {
    title: "Administración",
    path: "#",
    icon: <FaUserGear />,
    cName: "nav-text",
    hasOnClick: false,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    subNav: [
      {
        title: "Usuarios",
        path: "/users",
        icon: <FaIcons.FaUser />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Eventos",
        path: "/events",
        icon: <FaIcons.FaBell />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Productos",
        path: "/products",
        icon: <FaIcons.FaBoxOpen />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Categorias",
        path: "/categories",
        icon: <FaIcons.FaTags />,
        cName: "nav-text",
        hasOnClick: false,
      },
      {
        title: "Variaciones",
        path: "/variations",
        icon: <FaIcons.FaSwatchbook />,
        cName: "nav-text",
        hasOnClick: false,
      }
    ]
  },
  {
    title: "Salir",
    path: "/",
    icon: <IoMdExit />,
    cName: "nav-text",
    hasOnClick: true,
  },
];
